import { createAction, props } from '@ngrx/store';
import { CalculatedStreamDTO, KTLFGDOverrideRecordDTO } from 'src/app/web-api-client';

export const getMonthlyFuelGas = createAction(
  '[KTL] Get Monthly Fuel Gas',
  props<{ startTime: Date }>()
);
export const getMonthlyFuelGasSuccess = createAction(
  '[KTL] Get Monthly Fuel Gas Success',
  props<{ data: CalculatedStreamDTO[] }>()
);
export const getMonthlyFuelGasFailure = createAction(
  '[KTL] Get Monthly Fuel Gas Failure',
  props<{ message: string }>()
);

export const getMonthlyUpdatedFuelGas = createAction(
  '[KTL] Get Monthly Updated Fuel Gas',
  props<{ isDaily: boolean }>()
);
export const getMonthlyUpdatedFuelGasSuccess = createAction(
  '[KTL] Get Monthly Updated Fuel Gas Success',
  props<{ data: Date }>()
);
export const getMonthlyUpdatedFuelGasFailure = createAction(
  '[KTL] Get Monthly Updated Fuel Gas Failure',
  props<{ message: string }>()
);

export const getIsMonthlyRecordExist = createAction(
  '[KTL] Get Is Monthly Record Exist',
  props<{ startTime: Date; isMonthlyReport: boolean }>()
);
export const getIsMonthlyRecordExistSuccess = createAction(
  '[KTL] Get Is Monthly Record Exist Success',
  props<{ isMonthlyRecordExistdata: boolean }>()
);
export const getIsMonthlyRecordExistFailure = createAction(
  '[KTL] Get Is Monthly Record Exist Failure',
  props<{ message: string }>()
);

export const AddOverrideMonthlyManualRecords = createAction(
  '[KTL] Add Override Monthly Manual Records',
  props<{date: Date; props: KTLFGDOverrideRecordDTO[]}>()
);
export const AddOverrideMonthlyManualRecordsSuccess = createAction(
  '[KTL] Add Override Monthly Manual Records Success',
  props<any>()
);
export const AddOverrideMonthlyManualRecordsFailure = createAction(
  '[KTL] Add Override Monthly Manual Records Failure',
  props<{ message: string }>()
);

export const RefreshMonthlyManualRecords = createAction(
  '[KTL] Refresh Monthly Manual Records',
  props<{ date: Date }>()
);
export const RefreshMonthlyManualRecordsSuccess = createAction(
  '[KTL] Refresh Monthly Manual Records Success',
  props<any>()
);
export const RefreshMonthlyManualRecordsFailure = createAction(
  '[KTL] Refresh Monthly Manual Records Failure',
  props<{ message: string }>()
);